<h2 mat-dialog-title>Review Feedback</h2>

<mat-dialog-content class="feedback-review-body">
  <p class="feedback-review-intro">
    These changes were made while Feedback Tracking Mode was on. Select the ones worth logging,
    assign a feedback type to each, and add a comment if useful. Only checked rows are saved as feedback -
    everything still saves to the probate as normal either way.
  </p>

  <div class="feedback-types-error" *ngIf="feedbackTypesLoadFailed">
    Couldn't load feedback types, so a type can't be selected below - Approve is disabled until this is fixed.
  </div>

  <table class="feedback-review-table" *ngIf="rows.length > 0">
    <thead>
      <tr>
        <th class="include-col"></th>
        <th>Change</th>
        <th>Before</th>
        <th>After</th>
        <th>Feedback Type</th>
        <th>Comment</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows" [class.excluded]="!row.include">
        <td class="include-col"><input type="checkbox" [(ngModel)]="row.include" /></td>
        <td>{{ row.fieldPath }}</td>
        <td class="value-cell">{{ row.beforeValue ?? '—' }}</td>
        <td class="value-cell">{{ row.afterValue ?? '—' }}</td>
        <td>
          <select [(ngModel)]="row.feedbackTypeId" [disabled]="!row.include">
            <option [ngValue]="null">{{ loadingFeedbackTypes ? 'Loading...' : 'Select type...' }}</option>
            <option *ngFor="let t of feedbackTypes" [ngValue]="t.id">{{ t.description }}</option>
          </select>
        </td>
        <td>
          <input type="text" [(ngModel)]="row.comments" [disabled]="!row.include" placeholder="Optional comment" />
        </td>
      </tr>
    </tbody>
  </table>

  <div class="no-changes" *ngIf="rows.length === 0">No changes to review.</div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="feedback-review-actions" style="display:flex;gap:10px">
  <button class="btn cancel" (click)="cancel()">Cancel</button>
  <button class="btn save" [disabled]="!canApprove()" (click)="approve()">Approve &amp; Save</button>
</mat-dialog-actions>
